import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { validatePassword, PASSWORD_HINT } from "../passwordPolicy";
import usePlayerManifest from "../hooks/usePlayerManifest";
import PasswordInput from "../components/PasswordInput";
import api from "../api";

export default function PlayerResetPassword() {
  usePlayerManifest();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const submit = async () => {
    if (!password || !confirm) return setError("Both fields are required");
    if (password !== confirm) return setError("Passwords do not match");
    const passwordError = validatePassword(password);
    if (passwordError) return setError(passwordError);
    if (!token) return setError("Invalid reset link");
    setLoading(true); setError("");
    try {
      await api.post("/player/reset-password", { token, newPassword: password });
      setDone(true);
    } catch(e) { setError(e.response?.data?.error || "Reset failed"); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f0fdf4", display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}>
      <div style={{ background: "white", padding: "32px", borderRadius: "16px", boxShadow: "0 4px 24px rgba(0,0,0,0.10)", width: "100%", maxWidth: "420px" }}>
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <div style={{ width: "64px", height: "64px", background: "#14532d", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px", fontSize: "28px" }}>⛳</div>
          <h1 style={{ margin: 0, fontSize: "22px", fontWeight: "800", color: "#14532d" }}>Golf Society Manager</h1>
          <p style={{ margin: "6px 0 0", fontSize: "14px", color: "#6b7280" }}>Player — Set New Password</p>
        </div>

        {done ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "40px", marginBottom: "16px" }}>✅</div>
            <div style={{ fontWeight: "700", color: "#166534", marginBottom: "8px" }}>Password updated!</div>
            <p style={{ fontSize: "13px", color: "#6b7280", marginBottom: "20px" }}>You can now sign in with your new password.</p>
            <button onClick={() => navigate("/login")}
              style={{ background: "#166534", color: "white", border: "none", borderRadius: "8px", padding: "11px 24px", fontSize: "14px", fontWeight: "700", cursor: "pointer" }}>
              Sign In
            </button>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {error && <div style={{ background: "#fee2e2", color: "#b91c1c", padding: "10px 14px", borderRadius: "8px", fontSize: "13px" }}>{error}</div>}
            <div>
              <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>New Password</label>
              <PasswordInput value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === "Enter" && submit()}
                placeholder="Choose a new password"
                style={{ width: "100%", border: "1.5px solid #d1d5db", borderRadius: "8px", padding: "11px 14px", fontSize: "15px", boxSizing: "border-box" }} />
              <p style={{ fontSize: "13px", fontWeight: "600", color: "#4b5563", marginTop: "6px" }}>{PASSWORD_HINT}</p>
            </div>
            <div>
              <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>Confirm Password</label>
              <PasswordInput value={confirm} onChange={e => setConfirm(e.target.value)} onKeyDown={e => e.key === "Enter" && submit()}
                placeholder="Repeat your new password"
                style={{ width: "100%", border: "1.5px solid #d1d5db", borderRadius: "8px", padding: "11px 14px", fontSize: "15px", boxSizing: "border-box" }} />
            </div>
            <button onClick={submit} disabled={loading}
              style={{ width: "100%", background: loading ? "#86efac" : "#166534", color: "white", fontWeight: "700", fontSize: "16px", padding: "13px", borderRadius: "8px", border: "none", cursor: loading ? "not-allowed" : "pointer" }}>
              {loading ? "Updating..." : "Set New Password"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
